// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-bars-info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    max-width: 80%;
    margin: 10px auto;
}

.bar-info {
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
    margin: 10px 100px;
    border: 1px solid #e3e3e3;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.bar-info:hover {
    background-color: #f4e803;
    box-shadow: 0 0 20px rgba(0, 0, 0, 1);
}


.header-all-bars {
    top: 50px;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 40px;
    text-align: center;
    color: rgb(0, 0, 0);
    background: linear-gradient(to right, #ffffff 0%, #f4e803 50%, #ffffff 100%);
}

.text-all-bars {
    font-size: 20px;
    text-align: center;
    margin-top: 20px;
    width: 60%;
    margin: auto;
    margin-bottom: 100px;
}

.icon-container {
    margin-left: 10px;
    margin-top: -20px;
    position: absolute;
    cursor: pointer;
}


@media screen and (max-width: 1000px) {
    .all-bars-info {
        max-width: 100%;
    }

    .bar-info {
        margin: 10px 0px;
    }

    .text-all-bars {
        width: 80%;
    }

    .header-all-bars {
        font-size: 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/style/allBars.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;;AAGA;IACI,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,4EAA4E;AAChF;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".all-bars-info {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: space-around;\r\n    max-width: 80%;\r\n    margin: 10px auto;\r\n}\r\n\r\n.bar-info {\r\n    background-color: #f5f5f5;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n    margin: 10px 100px;\r\n    border: 1px solid #e3e3e3;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n}\r\n\r\n.bar-info:hover {\r\n    background-color: #f4e803;\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 1);\r\n}\r\n\r\n\r\n.header-all-bars {\r\n    top: 50px;\r\n    margin-left: 50%;\r\n    transform: translateX(-50%);\r\n    font-size: 40px;\r\n    text-align: center;\r\n    color: rgb(0, 0, 0);\r\n    background: linear-gradient(to right, #ffffff 0%, #f4e803 50%, #ffffff 100%);\r\n}\r\n\r\n.text-all-bars {\r\n    font-size: 20px;\r\n    text-align: center;\r\n    margin-top: 20px;\r\n    width: 60%;\r\n    margin: auto;\r\n    margin-bottom: 100px;\r\n}\r\n\r\n.icon-container {\r\n    margin-left: 10px;\r\n    margin-top: -20px;\r\n    position: absolute;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n@media screen and (max-width: 1000px) {\r\n    .all-bars-info {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .bar-info {\r\n        margin: 10px 0px;\r\n    }\r\n\r\n    .text-all-bars {\r\n        width: 80%;\r\n    }\r\n\r\n    .header-all-bars {\r\n        font-size: 25px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
